// @generated by protoc-gen-connect-es v1.7.0 with parameter "target=ts,import_extension=none"
// @generated from file mono/document/v1/document.proto (package mono.document.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
import { DeleteDocumentsRequest, DeleteDocumentsResponse, DownloadDocumentRequest, DownloadDocumentResponse, GetDocumentStatusRequest, GetDocumentStatusResponse, ListDocumentsRequest, ListDocumentsResponse, ProcessDocumentRequest, ProcessDocumentResponse } from "./document_pb";
import { MethodKind } from "@bufbuild/protobuf";
/**
 * DocumentService provides document processing operations.
 *
 * @generated from service mono.document.v1.DocumentService
 */ export const DocumentService = {
    typeName: "mono.document.v1.DocumentService",
    methods: {
        /**
     * ProcessDocument submits a document for processing.
     *
     * @generated from rpc mono.document.v1.DocumentService.ProcessDocument
     */ processDocument: {
            name: "ProcessDocument",
            I: ProcessDocumentRequest,
            O: ProcessDocumentResponse,
            kind: MethodKind.Unary
        },
        /**
     * GetDocumentStatus returns the processing status of a document.
     *
     * @generated from rpc mono.document.v1.DocumentService.GetDocumentStatus
     */ getDocumentStatus: {
            name: "GetDocumentStatus",
            I: GetDocumentStatusRequest,
            O: GetDocumentStatusResponse,
            kind: MethodKind.Unary
        },
        /**
     * DownloadDocument downloads a processed document.
     *
     * @generated from rpc mono.document.v1.DocumentService.DownloadDocument
     */ downloadDocument: {
            name: "DownloadDocument",
            I: DownloadDocumentRequest,
            O: DownloadDocumentResponse,
            kind: MethodKind.Unary
        },
        /**
     * ListDocuments returns paginated documents for the authenticated user.
     *
     * @generated from rpc mono.document.v1.DocumentService.ListDocuments
     */ listDocuments: {
            name: "ListDocuments",
            I: ListDocumentsRequest,
            O: ListDocumentsResponse,
            kind: MethodKind.Unary
        },
        /**
     * DeleteDocuments soft-deletes documents by ID.
     *
     * @generated from rpc mono.document.v1.DocumentService.DeleteDocuments
     */ deleteDocuments: {
            name: "DeleteDocuments",
            I: DeleteDocumentsRequest,
            O: DeleteDocumentsResponse,
            kind: MethodKind.Unary
        }
    }
};
